import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaStar, FaRegStar } from "react-icons/fa";
import {
  agregarPelicula,
  eliminarPelicula,
} from "../redux/slices/FavouriteSlice";
import { SeeMoreButton } from "./SeeMoreButton";
import AnimeModal from "./AnimeModal";

const AnimeCard = ({ anime }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const favoritos = useSelector((state) => state.favoritos.peliculas);

  // Verificar si el anime está en favoritos
  const isFavorite = favoritos.some((fav) => fav.id === anime.id && fav.type === 'anime');

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    if (isFavorite) {
      dispatch(eliminarPelicula({...anime, type: 'anime'}));
    } else {
      dispatch(agregarPelicula({...anime, type: 'anime'}));
    }
  };

  const handleMoreInfoClick = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };

  // Función para manejar el click en la tarjeta (ahora muestra el modal en lugar de navegar)
  const handleCardClick = () => {
    setShowModal(true);
  };

  return (
    <>
      <div
        className="relative m-4 transition-all duration-300 ease-in-out hover:scale-110 hover:z-10 cursor-pointer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleCardClick}
      >
        <div className="relative p-1 border border-white border-opacity-50 rounded-lg shadow-lg bg-black-800">
          <img
            src={anime.poster}
            alt={anime.name}
            className="object-cover w-full h-[200px] md:h-[250px] lg:h-[300px] rounded-lg"
          />
          {isHovered && (
            <div className="absolute inset-0 flex flex-col justify-end p-4 bg-black bg-opacity-75 rounded-lg">
              <h3 className="mb-2 text-xs font-bold text-white xl:text-lg 2xl:text-xl lg:text-base md:text-sm">
                {anime.name}
              </h3>
              {anime.releaseYear && (
                <span className="text-white">{anime.releaseYear}</span>
              )}
              {anime.genre && (
                <span className="text-white">{anime.genre}</span>
              )}
              {anime.totalSeasons && (
                <span className="text-white">{anime.totalSeasons} {anime.totalSeasons === 1 ? 'temporada' : 'temporadas'}</span>
              )}
              <div className="flex flex-col items-center justify-between lg:flex-row">
                <button
                  onClick={handleFavoriteClick}
                  className="p-2 rounded-full"
                >
                  {isFavorite ? (
                    <FaStar className="text-2xl text-yellow-500" />
                  ) : (
                    <FaRegStar className="text-2xl text-white" />
                  )}
                </button>

                <SeeMoreButton handleMoreInfoClick={handleMoreInfoClick} />
              </div>
            </div>
          )}
        </div>
      </div>
      {showModal && (
        <AnimeModal anime={anime} onClose={() => setShowModal(false)} />
      )}
    </>
  );
};

export default AnimeCard;
